export const ptBRAccounts = {
  loading: 'Carregando contas...',
  errorLoad: 'Falha ao carregar contas. Tente novamente.',
  pageTitle: 'Contas',
  addAccount: 'Adicionar Conta',
  noAccounts: 'Nenhuma conta ainda. Crie sua primeira conta.',
  modalCreateTitle: 'Criar Conta',
  modalEditTitle: 'Editar Conta',
  deleteTitle: 'Excluir Conta',
  deleteMessage: 'Tem certeza que deseja excluir "{{name}}"? Esta acao nao pode ser desfeita.',
  deleteConfirm: 'Excluir',
  typeCreditCard: 'Cartao de Credito',
  typeBankAccount: 'Conta Bancaria',
  typeDebitCard: 'Cartao de Debito',
  typeCash: 'Dinheiro',
  formNameLabel: 'Nome',
  formNamePlaceholder: 'ex: Nubank',
  formTypeLabel: 'Tipo de Conta',
  formSaving: 'Salvando...',
  formCreating: 'Criando...',
  formSave: 'Salvar',
  formCreate: 'Criar',
  formError: 'Falha ao salvar conta',
  validationNameRequired: 'Nome e obrigatorio',
  validationNameTooLong: 'Nome muito longo',
  noAccountsTitle: 'Nenhuma conta',
  noAccountsMessage: 'Adicione suas contas bancarias e cartoes de credito para rastrear pagamentos.',
  formColorLabel: 'Cor (opcional)',
  formColorPlaceholder: '#FF5733',
  validationColorInvalid: 'Cor deve ser um valor hexadecimal válido (ex: #FF5733)',
} as const;
